/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
import parse from "html-react-parser";
class StepItem extends Component {
  state = {
    view: false,
  };
  _onToggleView = () => {
    const { view } = this.state;

    this.setState({
      view: !view,
    });
  };
  _stepClick = () => {
    const { stepClick, cv_Idx } = this.props.childProps;
    stepClick(cv_Idx);
  };
  render() {
    const { view } = this.state;
    const { stepName, stepImage, stepLike, comment, kname } =
      this.props.childProps;

    let name = stepName.substr(0, stepName.indexOf("("));
    return (
      <Fragment>
        <div className="div_li">
          <div className="inmul_img">
            {/*<span><img src="/img/detail_img/min_top10.png"/></span>*/}
            <div>
              <img src={stepImage} />
            </div>
          </div>
          <h2>
            {name}

            <span>
              {/*<img src="/img/detail_img/etc_icon.png" style={{ cursor: 'pointer'}} onClick = {this._onToggleView}/>*/}
              {view ? (
                <div className="inmul_pop">
                  <ul>
                    <li>
                      리그 참전: 39회
                      <br />
                      리그 통산: 329승 15패 (0.956)
                      <br />
                      역대 득표: 72,329,668표
                    </li>
                    <li>
                      2016 애캐토 우승
                      <br />
                      2019 애캐토 8위
                    </li>
                  </ul>
                </div>
              ) : null}
            </span>
          </h2>
          <em
            style={{ cursor: "pointer", color: "#ff5d24" }}
            onClick={this._stepClick}
          >
            성우: {kname}
          </em>
          <p>{parse(comment)}</p>{" "}
          {/*parse(item.title.replace(/<[^>]+>/g, '')) */}
          <div className="right_img">
            {/*<img src="/img/heart_max.png"/>*/}
            {stepLike === 0 ? null : <strong>{stepLike}</strong>}
          </div>
        </div>
        {/*
                <div className="div_li">
                    <div className="inmul_img"><div><img src="/img/detail_img/test_img.png"/></div></div>
                    <h2>페코린느</h2>
                    <em>성우: 미나세 이노리</em>
                    <p>에밀리아 앞에 나타난 회색<br/>에밀리아 앞에 나타난 회</p>
                    <div className="right_img">
                        <img src="/img/heart_max.png"/>
                        <strong>2,304</strong>
                    </div>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(StepItem));
